import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { amountAsNumber } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import { DISCOUNT_POINTS, FieldConfig, roundToNearestInteger, roundToTheNearestTenth } from "./ClosingCostCalculator.utils.esm.js";
import ClosingCostContent from "./ClosingCostContent.esm.js";
import ClosingCostFields from "./ClosingCostFields.esm.js";
const DEFAULT_VALUES = {
  [FieldConfig.homePrice.name]: 4e5,
  [FieldConfig.downPayment.name]: 8e4,
  [FieldConfig.interestRate.name]: 5,
  [FieldConfig.purchasingAnyDiscountPoints.name]: DISCOUNT_POINTS.defaultPoint,
  [FieldConfig.discountPoints.name]: 0,
  [FieldConfig.creditReportFee.name]: 35,
  [FieldConfig.titleSearchFee.name]: 100,
  [FieldConfig.attorneyFees.name]: 500,
  [FieldConfig.appraisalFee.name]: 500,
  [FieldConfig.homeInspectionFee.name]: 400,
  [FieldConfig.pestInspectionFee.name]: 100,
  [FieldConfig.surveyFee.name]: 500,
  [FieldConfig.recordingFee.name]: 150,
  [FieldConfig.courierFee.name]: 20,
  [FieldConfig.notaryFee.name]: 100,
  [FieldConfig.hoaTransferFee.name]: 0,
  [FieldConfig.floodCertificationFee.name]: 15,
  [FieldConfig.bankProcessingFee.name]: 50,
  [FieldConfig.propertyTaxes.name]: 315,
  [FieldConfig.propertyTaxRate.name]: 0.77
};
const calculateDerivedValues = (values) => {
  const homePrice = amountAsNumber(values[FieldConfig.homePrice.name]);
  const downPayment = amountAsNumber(values[FieldConfig.downPayment.name]);
  const interestRate = values[FieldConfig.interestRate.name];
  return {
    [FieldConfig.interestRate.name]: interestRate,
    [FieldConfig.downPaymentPercent.name]: roundToTheNearestTenth(downPayment / homePrice * 100),
    [FieldConfig.loanOriginationFee.name]: roundToNearestInteger((homePrice - downPayment) * 0.5 / 100),
    [FieldConfig.titleInsurance.name]: roundToNearestInteger(homePrice * 0.5 / 100),
    [FieldConfig.settelementOrEscrowFee.name]: roundToNearestInteger(homePrice * 0.25 / 100),
    [FieldConfig.homeownerInsurance.name]: roundToNearestInteger(homePrice * 0.35 / 100),
    [FieldConfig.prepaidInterest.name]: roundToNearestInteger((homePrice - downPayment) * (interestRate / 100) / 365 * 15)
  };
};
const ClosingCostCalculator = ({
  defaultValues
}) => {
  const mergedValues = {
    ...DEFAULT_VALUES,
    ...omitUndefined(defaultValues)
  };
  const derivedValues = calculateDerivedValues(mergedValues);
  const finalDefaultValues = {
    ...mergedValues,
    ...derivedValues
  };
  return /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: "closingCostFields", editorMode: isEditor(), defaultValues: finalDefaultValues, children: /* @__PURE__ */ jsx(CalculatorLayout, { cssOverride: {
    flexDirection: "column-reverse",
    lg: {
      flexDirection: "row"
    }
  }, fields: /* @__PURE__ */ jsx(ClosingCostFields, {}), content: /* @__PURE__ */ jsx(ClosingCostContent, {}) }) });
};
export {
  ClosingCostCalculator as default
};
